module.exports = __webpack_public_path__ + "img/uk-flag.c16db563.png";